<template>
    <div v-show="show" class="cookie-alert">
        <div v-if="!this.showCookiePreferences" class="cookie-alert-content">
            <div class="cookie-alert-text">
                <p class="sidebar-title">Política de cookies</p>
                <p>
                    Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación y la generación de los correspondientes perfiles. Si continua navegando, consideramos que estás de acuerdo. <a href="/politica-privacidad" target="_blank">Ver política.</a>
                </p>
            </div>
            <div class="cookie-alert-buttons">
                <button @click="acceptCookies" class="btn btn-primary">
                    Aceptar todas
                </button>
                <button
                    @click="showCookiePreferences = true"
                    class="btn btn-aqs-aqua"
                >
                    Administrar preferencias
                </button>
            </div>
        </div>
        <cookie-preferences
            :showCookiePreferences="showCookiePreferences"
            @close="showCookiePreferences = false"
            @submit="() => acceptCookies()"
            id="cookie-preferences"
        />
        <div class="cookie-alert-overlay"></div>
    </div>
</template>

<script>
export default {
    props: {
        showAfter: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            showAfterPassed: this.showImmediately,
            showCookiePreferences: false
        };
    },
    computed: {
        cookiesAccepted() {
            return !!this.$cookies.get("cookies-accepted");
        },
        show() {
            return !this.cookiesAccepted && this.showAfterPassed;
        },
        showImmediately() {
            return this.showAfter > 1;
        }
    },
    methods: {
        setCookiesAccepted(accepted) {
            return this.$cookies.set("cookies-accepted", accepted);
        },
        acceptCookies() {
            return this.setCookiesAccepted(true);
        }
    },
    mounted() {
        if (this.cookiesAccepted === null) {
            this.setCookiesAccepted(false);
        }
        if (!this.showImmediately) {
            setTimeout(() => (this.showAfterPassed = true), this.showAfter);
        }
    }
};
</script>
